define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/table/Copy"
], function(declare,_,Copy) {

	return declare(Copy, {
		/**
		 * For the SDI form, we have defined the OOTB Form without any fields via the XML by default
		 * So, Don't show the Form if no additional fields
		 * @param {ViewRef} vr
		 */
		getActionView: function(vr) {
			var av = this.inherited(arguments);
			return _.isEmpty(av.m_defView.m_fields) ? null : av;
		}
	});
});